function ExpensesEmptyIcon() {
  return (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.442 84.3701C21.2303 84.3714 21.0219 84.3178 20.837 84.2146C20.6522 84.1114 
        20.4972 83.9622 20.3871 83.7813C20.3065 83.6406 20.2546 83.4853 20.2344 83.3243C20.2142 
        83.1634 20.2261 83.0001 20.2695 82.8438C20.3128 82.6875 20.3867 82.5414 20.4869 
        82.4138C20.5871 82.2863 20.7116 82.1799 20.8532 82.1008L25.3428 79.4021C26.7039 
        78.5914 28.2604 78.1673 29.8447 78.1755H49.5204C51.0502 78.1839 52.5656 77.8791 
        53.9732 77.28L76.1636 67.8715C76.6243 67.6814 77.0431 67.4024 77.396 67.0505C77.7489 
        66.6986 78.029 66.2806 78.2204 65.8204C78.4117 65.3602 78.5106 64.8668 78.5113 
        64.3685C78.512 63.8701 78.4145 63.3764 78.2244 62.9157C78.0343 62.455 77.7554 
        62.0362 77.4034 61.6833C77.0515 61.3304 76.6335 61.0503 76.1734 60.859C75.7132 
        60.6676 75.2198 60.5687 74.7214 60.568C74.223 60.5674 73.7294 60.6648 73.2687 
        60.8549L51.25 69.2208C51.0994 69.278 50.939 69.305 50.778 69.3002C50.6169 
        69.2954 50.4584 69.2589 50.3114 69.1928C50.1645 69.1268 50.032 69.0324 
        49.9215 68.9151C49.8111 68.7978 49.7248 68.66 49.6676 68.5093C49.6104 
        68.3587 49.5834 68.1983 49.5882 68.0373C49.593 67.8762 49.6295 67.7177 
        49.6956 67.5707C49.7616 67.4238 49.856 67.2913 49.9733 67.1808C50.0906 
        67.0704 50.2285 66.9841 50.3791 66.9269L72.3732 58.5488C73.8931 57.9889 
        75.5709 58.0402 77.0536 58.6921C78.5364 59.3439 79.7085 60.5455 80.3235 
        62.0439C80.9384 63.5424 80.9482 65.2209 80.3508 66.7264C79.7535 68.2319 
        78.5954 69.4471 77.1204 70.1163L54.9055 79.5125C53.2021 80.2347 51.3706 
        0.606 49.5204 80.6043H29.7956C28.6538 80.6074 27.5343 80.9212 26.5572 
        81.512L22.0799 84.1984C21.887 84.3129 21.6663 84.3723 21.442 84.3701Z"
        fill="#023B58"
      />
      <path
        d="M49.5695 69.3066H34.4937C34.1684 69.3066 33.8564 69.1773 33.6264 
        68.9473C33.3963 68.7172 33.2671 68.4052 33.2671 68.0799C33.2671 67.7546 
        33.3963 67.4426 33.6264 67.2125C33.8564 66.9825 34.1684 66.8532 34.4937 
        66.8532H49.5695C50.5391 66.7981 51.4508 66.3741 52.1178 65.6681C52.7847 
        64.9622 53.1563 64.0279 53.1563 63.0567C53.1563 62.0855 52.7847 61.1512 
        52.1178 60.4453C51.4508 59.7393 50.5391 59.3153 49.5695 59.2602H29.6729C28.1095 
        59.2631 26.5757 59.6868 25.2324 60.4868L12.4996 67.8836C12.2193 68.0303 11.8931 
        68.0629 11.5892 67.9748C11.2854 67.8866 11.0273 67.6845 10.869 67.4106C10.7107 
        67.1367 10.6643 66.8122 10.7396 66.5049C10.8148 66.1976 11.0059 65.9312 11.2729
         65.7615L23.9935 58.4015C25.7176 57.3967 27.6774 56.8676 29.6729 
         56.8682H49.5695C51.1791 56.9395 52.6992 57.6291 53.813 58.7934C54.9269 
         59.9577 55.5485 61.5068 55.5485 63.118C55.5485 64.7293 54.9269 66.2784 
         53.813 67.4427C52.6992 68.6069 51.1791 69.2966 49.5695 69.3679V69.3066Z"
        fill="#023B58"
      />
      <path
        d="M14.401 90.6503C14.1218 90.6543 13.8496 90.5629 13.6294 90.3913C13.4092 
        90.2197 13.2541 89.9781 13.1897 89.7064C13.1254 89.4348 13.1557 89.1493 13.2755 
        88.8971C13.3954 88.645 13.5977 88.4412 13.849 88.3196L20.1786 85.1671L8.91776 
        67.1719L2.45323 70.4348C2.30849 70.5175 2.14842 70.5698 1.98279 70.5886C1.81716 
        70.6074 1.64944 70.5922 1.48987 70.544C1.33031 70.4958 1.18224 70.4155 1.05472 
        70.3082C0.92719 70.2008 0.822883 70.0686 0.74816 69.9196C0.602663 69.6299 0.577762 
        69.2944 0.678898 68.9864C0.780034 68.6784 0.998983 68.4229 1.28789 68.2759L8.81963 
        64.51C9.09402 64.3724 9.41002 64.3427 9.70525 64.4267C10.0005 64.5108 10.2535 64.7024 
        10.4143 64.9639L22.9754 85.0199C23.0646 85.1653 23.1226 85.3277 23.1455 
        85.4968C23.1684 85.6659 23.1558 85.8379 23.1084 86.0018C23.0611 86.1658 
        22.9801 86.318 22.8706 86.4489C22.7611 86.5797 22.6255 86.6863 22.4724 
        86.7618L14.953 90.5276C14.781 90.6109 14.592 90.6529 14.401 90.6503Z"
        fill="#023B58"
      />
      <path
        d="M25.073 57.1382C21.725 57.1382 18.4521 56.1454 15.6683 54.2854C12.8845 
        52.4253 10.7148 49.7815 9.43359 46.6883C8.15235 43.5951 7.81712 40.1915 8.47029 
        36.9077C9.12346 33.624 10.7357 30.6078 13.1031 28.2403C15.4705 25.8729 18.4868 
        24.2607 21.7705 23.6075C25.0542 22.9543 28.4579 23.2896 31.5511 24.5708C34.6443 
        25.852 37.2881 28.0217 39.1481 30.8055C41.0082 33.5893 42.001 36.8622 42.001 
        40.2102C41.9978 44.6988 40.2133 49.0026 37.0393 52.1765C33.8654 55.3505 29.5616 
        57.135 25.073 57.1382ZM25.073 25.7356C22.2102 25.7356 19.4117 26.5845 17.0313 
        28.175C14.651 29.7655 12.7957 32.0261 11.7002 34.671C10.6046 37.3159 10.318 
        40.2263 10.8765 43.0341C11.435 45.8419 12.8136 48.4211 14.8379 50.4454C16.8622 
        52.4697 19.4413 53.8483 22.2492 54.4068C25.057 54.9653 27.9673 54.6786 30.6122 
        53.5831C33.2571 52.4875 35.5178 50.6323 37.1083 48.2519C38.6988 45.8716 39.5477 
        43.0731 39.5477 40.2102C39.538 36.3766 38.009 32.7031 35.2959 29.9945C32.5828 
        27.286 28.9067 25.7633 25.073 25.7601V25.7356Z"
        fill="#023B58"
      />
      <path
        d="M25.2324 49.729C21.7119 49.729 18.4857 46.8708 18.3508 46.7482C18.1084 
        46.5302 17.9626 46.2249 17.9453 45.8993C17.9281 45.5738 18.0408 45.2548 18.2588 
        45.0124C18.4768 44.77 18.7821 44.6242 19.1076 44.6069C19.4331 44.5897 19.7522 
        44.7024 19.9945 44.9204C19.9945 44.9204 22.6687 47.2756 25.2324 47.2756C27.4036 
        47.2756 28.5935 46.282 28.5935 44.4666C28.5935 42.921 27.146 42.2218 24.7908 
        41.2036C22.4356 40.1855 19.3689 38.8607 19.3689 35.4874C19.4605 34.1268 20.0851 
        32.8574 21.1072 31.9547C22.1292 31.0521 23.4662 30.5892 24.8276 30.6666C27.0253 
        30.7488 29.1198 31.6197 30.7279 33.1199C30.9326 33.3516 31.0423 33.6521 31.035 
        33.9613C31.0276 34.2704 30.9038 34.5654 30.6882 34.7871C30.4727 35.0089 30.1814 
        35.141 29.8726 35.1571C29.5638 35.1732 29.2603 35.0721 29.0228 34.874C27.8662 
        33.8266 26.3855 33.2075 24.8276 33.1199C24.1185 33.0432 23.4075 33.2464 22.8461 
        33.6864C22.2847 34.1264 21.9173 34.7682 21.8223 35.4751C21.8223 37.1556 23.3188 
        37.9284 25.7599 38.9343C28.2009 39.9402 31.0468 41.2159 31.0468 44.4543C31.0468 
        47.6927 28.7652 49.729 25.2324 49.729Z"
        fill="#023B58"
      />
      <path
        d="M25.0729 33.1932C24.7475 33.1932 24.4355 33.0639 24.2055 32.8339C23.9754 
        32.6038 23.8462 32.2918 23.8462 31.9665V29.4396C23.8462 29.1142 23.9754 28.8022 
        24.2055 28.5722C24.4355 28.3421 24.7475 28.2129 25.0729 28.2129C25.3982 28.2129 
        25.7102 28.3421 25.9402 28.5722C26.1703 28.8022 26.2995 29.1142 26.2995 
        29.4396V31.8929C26.3096 32.0601 26.2853 32.2275 26.2282 32.3849C26.171 32.5424 
        26.0823 32.6864 25.9673 32.8083C25.8524 32.9301 25.7138 33.0271 25.5599 33.0933C25.4061 
        33.1595 25.2403 33.1935 25.0729 33.1932Z"
        fill="#023B58"
      />
      <path
        d="M25.0729 52.1205C24.7475 52.1205 24.4355 51.9913 24.2055 51.7612C23.9754 
        51.5312 23.8462 51.2192 23.8462 50.8939V48.4405C23.8462 48.1152 23.9754 47.8032 
        24.2055 47.5731C24.4355 47.3431 24.7475 47.2139 25.0729 47.2139C25.3982 47.2139 
        25.7102 47.3431 25.9402 47.5731C26.1703 47.8032 26.2995 48.1152 26.2995 
        48.4405V50.8939C26.2995 51.2192 26.1703 51.5312 25.9402 51.7612C25.7102 51.9913 
        25.3982 52.1205 25.0729 52.1205Z"
        fill="#023B58"
      />
      <path
        d="M74.4585 59.5542C71.1105 59.5542 67.8376 58.5614 65.0538 56.7014C62.27 
        54.8413 60.1003 52.1975 58.8191 49.1043C57.5379 46.0111 57.2026 42.6075 57.8558 
        39.3238C58.509 36.0401 60.1212 33.0238 62.4886 30.6563C64.856 28.2889 67.8723 
        26.6767 71.156 26.0235C74.4397 25.3703 77.8434 25.7056 80.9366 26.9868C84.0298 
        28.2681 86.6736 30.4378 88.5336 33.2216C90.3937 36.0054 91.3865 39.2782 91.3865
         42.6263C91.3833 47.1148 89.5987 51.4187 86.4248 54.5926C83.2509 57.7665 
         78.9471 59.551 74.4585 59.5542ZM74.4585 28.1516C71.5957 28.1516 68.7972 
         29.0005 66.4168 30.591C64.0365 32.1815 62.1812 34.4421 61.0857 37.087C59.9901 
         39.7319 59.7035 42.6423 60.262 45.4501C60.8205 48.2579 62.1991 50.8371 
         64.2234 52.8614C66.2477 54.8857 68.8268 56.2643 71.6347 56.8228C74.4425 
         57.3813 77.3528 57.0947 79.9977 55.9991C82.6426 54.9035 84.9033 53.0483 
         86.4938 50.6679C88.0843 48.2876 88.9332 45.4891 88.9332 42.6263C88.9105 
         38.8 87.3763 35.1378 84.6649 32.4379C81.9536 29.738 78.2849 28.2193 
         74.4585 28.2129V28.1516Z"
        fill="#023B58"
      />
      <path
        d="M74.4586 45.5094C74.2424 45.5103 74.0299 45.454 73.8425 45.3463C73.6551 
        45.2386 73.4995 45.0833 73.3914 44.8961L66.7797 33.3286C66.6991 33.1879 66.6472 
        33.0325 66.627 32.8716C66.6068 32.7107 66.6187 32.5474 66.6621 32.3911C66.7054 
        32.2348 66.7793 32.0886 66.8795 31.9611C66.9797 31.8336 67.1042 31.7272 67.2458 
        31.6481C67.5275 31.4881 67.8609 31.4461 68.1735 31.5311C68.486 31.6162 68.7522 
        31.8214 68.9141 32.1019L74.4586 41.8171L80.0031 32.1019C80.0837 31.9618 80.191 
        31.8389 80.3191 31.7402C80.4471 31.6416 80.5933 31.5691 80.7494 31.5269C80.9055 
        31.4848 81.0683 31.4738 81.2286 31.4946C81.3889 31.5154 81.5435 31.5675 81.6837 
        31.6481C81.8238 31.7286 81.9467 31.836 82.0454 31.964C82.144 32.0921 82.2165 
        32.2383 82.2587 32.3943C82.3008 32.5504 82.3118 32.7132 82.291 32.8735C82.2702 
        33.0338 82.2181 33.1885 82.1375 33.3286L75.5258 44.8961C75.4177 45.0833 75.2621 
        45.2386 75.0747 45.3463C74.8873 45.454 74.6748 45.5103 74.4586 45.5094Z"
        fill="#023B58"
      />
      <path
        d="M74.4586 55.4205C74.1333 55.4205 73.8213 55.2912 73.5912 55.0612C73.3612 
        54.8311 73.2319 54.5191 73.2319 54.1938V44.2823C73.2319 43.957 73.3612 43.645 
        73.5912 43.415C73.8213 43.1849 74.1333 43.0557 74.4586 43.0557C74.7839 43.0557 
        75.0959 43.1849 75.326 43.415C75.556 43.645 75.6853 43.957 75.6853 44.2823V54.1938C75.6853 
        54.5191 75.556 54.8311 75.326 55.0612C75.0959 55.2912 74.7839 55.4205 
        74.4586 55.4205Z"
        fill="#023B58"
      />
      <path
        d="M80.2484 45.509H68.6932C68.3679 45.509 68.0559 45.3798 67.8258 
        45.1497C67.5958 44.9197 67.4666 44.6077 67.4666 44.2823C67.4666 43.957 
        67.5958 43.645 67.8258 43.415C68.0559 43.1849 68.3679 43.0557 68.6932 
        43.0557H80.2607C80.586 43.0557 80.898 43.1849 81.1281 43.415C81.3581 
        43.645 81.4874 43.957 81.4874 44.2823C81.4874 44.6077 81.3581 44.9197 81.1281 
        45.1497C80.898 45.3798 80.586 45.509 80.2607 45.509H80.2484Z"
        fill="#023B58"
      />
      <path
        d="M80.2484 48.8215H68.6932C68.3679 48.8215 68.0559 48.6923 67.8258 
        48.4622C67.5958 48.2322 67.4666 47.9202 67.4666 47.5948C67.4666 47.2695 
        67.5958 46.9575 67.8258 46.7274C68.0559 46.4974 68.3679 46.3682 68.6932 
        46.3682H80.2607C80.586 46.3682 80.898 46.4974 81.1281 46.7274C81.3581 
        46.9575 81.4874 47.2695 81.4874 47.5948C81.4874 47.9202 81.3581 48.2322 
        81.1281 48.4622C80.898 48.6923 80.586 48.8215 80.2607 48.8215H80.2484Z"
        fill="#023B58"
      />
      <path
        d="M54.2185 19.4914H44.2948C43.9694 19.4914 43.6574 19.3622 43.4274 19.1321C43.1974 
        18.9021 43.0681 18.5901 43.0681 18.2648C43.0681 17.9394 43.1974 17.6274 43.4274 
        17.3974C43.6574 17.1673 43.9694 17.0381 44.2948 17.0381H54.2185C54.5438 17.0381 
        54.8559 17.1673 55.0859 17.3974C55.3159 17.6274 55.4452 17.9394 55.4452 18.2648C55.4452 
        18.5901 55.3159 18.9021 55.0859 19.1321C54.8559 19.3622 54.5438 19.4914 54.2185 
        19.4914Z"
        fill="#023B58"
      />
      <path
        d="M45.3865 27.453C45.0904 27.4488 44.8031 27.3515 44.5654 27.1749C44.3276 
        26.9984 44.1515 26.7514 44.0619 26.4692C43.9723 26.1869 43.9739 25.8836 44.0663 
        25.6022C44.1588 25.3208 44.3374 25.0757 44.5769 24.9016C45.4842 24.215 46.1755 
        23.2827 46.569 22.2152C46.9626 21.1477 47.0417 19.9898 46.7972 18.8786C46.7148 
        18.5121 46.6083 18.1515 46.4783 17.7992C45.9017 16.0941 45.0308 13.5181 46.3311 
        11.3346C46.8091 10.4548 47.5194 9.7231 48.3845 9.21913C49.2497 8.71516 50.2366 
        8.45829 51.2377 8.47649C52.2404 8.4824 53.2286 8.71629 54.1275 9.16045C55.0265 
        9.60461 55.8126 10.2474 56.4265 11.0402C56.52 11.1715 56.5866 11.3199 56.6227 
        11.477C56.6588 11.634 56.6636 11.7966 56.6368 11.9555C56.61 12.1144 56.5522 12.2665 
        56.4667 12.4031C56.3811 12.5396 56.2695 12.658 56.1383 12.7514C56.007 12.8449 
        55.8586 12.9115 55.7015 12.9476C55.5445 12.9837 55.3819 12.9885 55.223 12.9617C55.0641 
        12.9349 54.912 12.8771 54.7754 12.7916C54.6389 12.706 54.5205 12.5944 54.4271 
        12.4632C54.0429 11.9945 53.5601 11.6163 53.0131 11.3555C52.4661 11.0947 51.8683 
        10.9577 51.2623 10.9544C50.6943 10.9279 50.1305 11.0624 49.6357 11.3423C49.1409 
        11.6223 48.7352 12.0363 48.4655 12.5368C47.7049 13.8248 48.3305 15.6893 48.7844 
        17.0386C48.9787 17.5392 49.1265 18.0566 49.226 18.5842C49.5292 20.4979 49.2246 
        22.4586 48.3551 24.1901C48.7897 24.1265 49.2283 24.0937 49.6676 24.092C50.4409 
        24.1331 51.2066 24.2649 51.9492 24.4845C52.6175 24.6773 53.304 24.8006 53.9977 
        24.8525C54.5633 24.8409 55.1166 24.6847 55.6047 24.3986C55.8751 24.2211 56.2047 
        24.1576 56.5218 24.2219C56.8388 24.2862 57.1176 24.4732 57.2975 24.7421C57.4774 
        25.0096 57.5448 25.3371 57.4851 25.6539C57.4254 25.9707 57.2434 26.2512 56.9785 
        26.4349C56.0841 26.9941 55.0526 27.2955 53.9977 27.3058C53.1085 27.2616 52.2274 
        27.1134 51.3727 26.8642C50.8156 26.7047 50.2447 26.5979 49.6676 26.5453C48.358 
        26.6061 47.0681 26.8881 45.8527 27.3794C45.7035 27.4339 45.5452 27.4589 45.3865 27.453Z"
        fill="#023B58"
      />
      <path
        d="M50.9065 35.1929C47.5585 35.1929 44.2856 34.2001 41.5018 32.34C38.718 
        30.48 36.5483 27.8362 35.2671 24.743C33.9859 21.6498 33.6506 18.2461 34.3038 
        14.9624C34.957 11.6787 36.5692 8.66244 38.9366 6.29502C41.304 3.92759 44.3203 
        2.31536 47.604 1.66219C50.8877 1.00902 54.2914 1.34425 57.3846 2.62549C60.4778 
        3.90673 63.1216 6.07643 64.9816 8.86023C66.8417 11.644 67.8345 14.9169 67.8345 
        18.2649C67.8313 22.7535 66.0468 27.0573 62.8728 30.2312C59.6989 33.4051 55.3951 
        35.1897 50.9065 35.1929ZM50.9065 3.80252C48.0432 3.80252 45.2442 4.65176 42.8636 
        6.2428C40.4829 7.83384 38.6277 10.0952 37.5325 12.7408C36.4373 15.3864 36.1514 
        18.2974 36.7109 21.1056C37.2704 23.9137 38.6502 26.4928 40.6757 28.5167C42.7013 
        30.5405 45.2816 31.9181 48.0902 32.4752C50.8988 33.0323 53.8096 32.7439 56.4542 
        31.6465C59.0989 30.5491 61.3587 28.6919 62.9477 26.31C64.5368 23.928 65.3836 
        21.1283 65.3812 18.2649C65.3747 14.4291 63.8472 10.7525 61.1337 8.0413C58.4203 5.33013 
        54.7423 3.80576 50.9065 3.80252Z"
        fill="#023B58"
      />
    </svg>
  );
}

export default ExpensesEmptyIcon;
